import affiliate from '../plugins/affiliate'

const beforeEach = async (to, from, next) => {
  affiliate.code = to.params.affiliate

  if (affiliate.hasCode()) {
    if (await affiliate.isValid()) {
      affiliate.create()
    } else {
      return next({ name: 'home' })
    }
  }

  return next()
}

export default beforeEach
